import homePortfolio from "../../pics/home/homePortfolio.png";
import { NavLink } from "react-router-dom";
import FlowingPics from "../../components/FlowingPics";
import images from "../../pics/home/slide";

export default function Home() {
  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <div>
      {/* Flowing image header section */}
      <div className="relative bg-slate-200">
        <FlowingPics images={images} />
      </div>

      {/* Portfolio Section */}
      <section
        id="portfolio"
        className="flex flex-col lg:flex-row justify-center items-center gap-10 bg-stone-100 py-16 px-6 md:px-20 transition-all duration-500"
      >
        {/* Portfolio Image */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={homePortfolio}
            alt="homePortfolio"
            className="rounded-xl shadow-xl max-w-md w-full h-auto object-cover"
          />
        </div>

        {/* Text Content */}
        <div className="w-full lg:w-1/2 text-center">
          <h2 className="text-4xl md:text-5xl font-semibold mb-6">
            Portfolio
          </h2>
          <p className="text-lg md:text-2xl font-light text-gray-700 leading-relaxed px-2 md:px-6">
            Few people are lucky enough to stand in front of the incredible sandstone formation "The Wave" in Arizona and admire the unique forms of nature that have been created there over millions of years. In the images on this website, you can experience a wild nature that only exists in continously shrinking  fragments on our earth, but also the fascination of near-natural landscapes with its animals in densely populated Europe
          </p>

          {/* Button */}
          <div className="mt-8">
            <NavLink to="/portfolio">
              <button
                onClick={scrollToTop}
                className="text-lg md:text-xl bg-stone-500 text-white px-6 py-3 rounded-lg hover:bg-stone-400 hover:text-black transition"
              >
                View Portfolio
              </button>
            </NavLink>
          </div>
        </div>
      </section>
    </div>
  );
}
